import { ManagerUpdates } from '@/components/managerUpdates-page';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const ManagerUpdatesPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Manager Updates</title>
      </Head>
      <ManagerUpdates />
    </>
  );
};

export default ManagerUpdatesPage;
